import React, { useCallback, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selectCurrentOrganisation } from '../../../../redux/selectors/organisations';
import {
  selectCurrentOrganisationId,
  selectCurrentUserId,
  selectIsHeadOrTrustedEmployee,
} from '../../../../redux/selectors/auth';
import Item from '../Item/Item';
import NewLoader from '../../../../components/NewLoader';

const Archive = (props) => {
  const history = useHistory();
  const [ready, setReady] = useState(false);
  const { applications } = useSelector((state) => state);
  const currentOrganisation = useSelector(selectCurrentOrganisation);
  const isHeadOrTrustedEmployee = useSelector(selectIsHeadOrTrustedEmployee);
  const currentUserId = useSelector(selectCurrentUserId);
  const currentOrganisationId = useSelector(selectCurrentOrganisationId);

  const getList = useCallback(async () => {
    setReady(false);
    let data = [];
    if (currentOrganisation && currentOrganisation.type === 0) {
      data = [
        { name: 'status', value: '16' },
        { name: 'status', value: '20' },
        { name: 'status', value: '21' },
        { name: 'status', value: '22' },
        { name: 'createdByOrganisationId', value: currentOrganisationId },
      ];
    } else if (!currentOrganisationId) {
      data = [{ name: 'status', value: '0' }];
    } else if (currentOrganisation && currentOrganisation.type === 1) {
      data = [
        { name: 'status', value: '16' },
        { name: 'status', value: '20' },
        { name: 'status', value: '21' },
        { name: 'status', value: '22' },
        { name: 'regionId', value: currentOrganisation.regionId },
      ];
    } else if (currentOrganisation && currentOrganisation.type === 2) {
      data = [
        { name: 'status', value: '16' },
        { name: 'status', value: '20' },
        { name: 'status', value: '21' },
        { name: 'status', value: '22' },
      ];
    } else if (currentOrganisation && currentOrganisation.type === 3) {
      data = [
        { name: 'status', value: '16' },
        { name: 'status', value: '20' },
        { name: 'status', value: '21' },
        { name: 'status', value: '22' },
        { name: 'sportCategoryType', value: 0 },
      ];
    } else if (currentOrganisation && currentOrganisation.type === 4) {
      data = [
        { name: 'status', value: '16' },
        { name: 'status', value: '20' },
        { name: 'status', value: '21' },
        { name: 'status', value: '22' },
        { name: 'sportCategoryType', value: 1 },
      ];
    } else if (currentOrganisation && currentOrganisation.type === 5) {
      data = [
        { name: 'status', value: '16' },
        { name: 'status', value: '20' },
        { name: 'status', value: '21' },
        { name: 'status', value: '22' },
        { name: 'sportCategoryType', value: 2 },
      ];
    } else if (currentOrganisation && currentOrganisation.type === 6 && !isHeadOrTrustedEmployee) {
      data = [
        { name: 'status', value: '16' },
        { name: 'status', value: '20' },
        { name: 'status', value: '21' },
        { name: 'status', value: '22' },
        { name: 'federationId', value: currentOrganisation.id },
      ];
    } else if (currentOrganisation && currentOrganisation.type === 6 && isHeadOrTrustedEmployee) {
      data = [
        { name: 'status', value: '16' },
        { name: 'status', value: '20' },
        { name: 'status', value: '21' },
        { name: 'status', value: '22' },
        { name: 'federationId', value: currentOrganisation.id },
      ];
    } else if (
      currentOrganisation &&
      (currentOrganisation.type === 7 || currentOrganisation.type === 8)
    ) {
      data = [
        { name: 'status', value: '16' },
        { name: 'status', value: '20' },
        { name: 'status', value: '21' },
        { name: 'status', value: '22' },
        { name: 'trainerId', value: currentUserId },
      ];
    } else if (currentOrganisation && currentOrganisation.type === 9) {
      data = [
        { name: 'status', value: '16' },
        { name: 'status', value: '20' },
        { name: 'status', value: '21' },
        { name: 'status', value: '22' },
        { name: 'federationId', value: currentOrganisation.id },
      ];
    } else if (currentOrganisation && currentOrganisation.type === 10) {
      data = [
        { name: 'status', value: '16' },
        { name: 'status', value: '22' },
      ];
    }
    if (sessionStorage.arch) {
      let arch = JSON.parse(sessionStorage.arch);

      props.setFilterForm(arch);
      arch.forEach((element) => {
        if (element && element.value.length > 0) {
          data.push(element);
        }
      });
      props.setReload(false);
    }

    if (props.sort) {
      data.push({ sortName: props.sort.sortName, sortValue: props.sort.sortValue });
    }

    if (props.search) {
      data.push({ name: 'all', value: props.search });
    }

    if (props.subtab.refused) {
      data = data.filter((filter) => !(filter.name === 'status' && filter.value !== '16'));
    }
    if (props.subtab.confirmed) {
      data = data.filter((filter) => !(filter.name === 'status' && filter.value === '16'));
    }

    props.setData(data);
    await props.getApplications(data, props.currentPage).then(res=>{
      setReady(true);
    });
  }, [
    applications,
    currentOrganisation,
    props.search,
    props.sort,
    props.currentPage,
    props.subtab,
  ]);

  useEffect(() => {
    void getList();
  }, [
    currentOrganisation,
    props.search,
    props.reload,
    props.sort,
    props.currentPage,
    props.subtab,
  ]);

  return (
    <>
      {(ready &&
        applications &&
        applications.list &&
        applications.list.length > 0) ?
        applications.list.map((item) => {
          return <Item item={item} type={props.type} key={item.id} history={history} />;
        }):
        <tr >
          <td colSpan="9">
          {ready && applications?.list?.length==0?<h2>Жодної заявки</h2>
          : <NewLoader/>}
          </td>
        </tr>
      }  
    </>
  );
};

export default Archive;
